import { Handle, Position } from '@xyflow/react'
import { useState, useEffect, useRef } from 'react'
import { isFired } from './useFiredFlash'

export function PrefabSlotNode({ data, selected }) {
  const fired    = isFired(data)
  const [active, setActive] = useState(false)
  const [tag,    setTag]    = useState('')
  const tickRef  = useRef(-1)

  useEffect(() => {
    const id = setInterval(() => {
      const tick = window.__DEBUG_STATE__?.tick ?? 0
      if (tick === tickRef.current) return
      tickRef.current = tick
      const state = window.__PREFAB_ACTIVE__
      const isActive = !!(state?.clipName && Date.now() < state.expiresAt)
      setActive(isActive)
      setTag(isActive ? (state.tag ?? state.clipName) : '')
    }, 100)
    return () => clearInterval(id)
  }, [])

  const accent       = '#c080ff'
  const blendInTime  = data.blendInTime  ?? 0.1
  const blendOutTime = data.blendOutTime ?? 0.1

  return (
    <div style={{
      background: selected ? '#1a0a2a' : '#110718',
      border: `2px solid ${fired ? '#ffcc44' : active ? accent : selected ? '#8040cc' : '#3a1a5a'}`,
      borderRadius: 6,
      minWidth: 210,
      fontFamily: 'var(--m-font)',
      boxShadow: active ? `0 0 14px ${accent}55` : fired ? '0 0 14px rgba(255,200,40,0.6)' : 'none',
    }}>
      {/* Header */}
      <div style={{
        background: active ? '#2a1040' : selected ? '#1a0a30' : '#130820',
        padding: '6px 12px',
        display: 'flex', alignItems: 'center', gap: 8,
        borderRadius: '4px 4px 0 0',
        position: 'relative',
      }}>
        {/* Pose input handle */}
        <Handle type="target" position={Position.Left} id="pose"
          style={{ background: '#e07040', width: 10, height: 10,
                   border: '2px solid #a04020', top: '50%', transform: 'translateY(-50%)' }} />
        <span style={{ fontSize: 13 }}>🎭</span>
        <span style={{ color: accent, fontWeight: 'bold', fontSize: 11, letterSpacing: 0.5 }}>
          PREFAB SLOT
        </span>
        {active && (
          <span style={{ color: '#ffcc44', fontSize: 9, marginLeft: 'auto' }}>● ACTIVE</span>
        )}
        {/* Anim output handle */}
        <Handle type="source" position={Position.Right} id="anim"
          style={{ background: '#e07040', width: 10, height: 10,
                   border: '2px solid #a04020', top: '50%', transform: 'translateY(-50%)' }} />
      </div>

      {/* Current tag display */}
      <div style={{ padding: '5px 12px 4px', minHeight: 24 }}>
        <span style={{ color: active ? '#d0a0ff' : '#3a2a4a', fontSize: 10, wordBreak: 'break-all' }}>
          {active ? tag : '—'}
        </span>
      </div>

      {/* Blend times */}
      <div style={{ padding: '4px 12px', borderTop: '1px solid #1e0a30' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
          <span style={{ color: '#5a3a7a', fontSize: 9, flex: 1 }}>Blend In</span>
          <input
            type="number" min={0} max={5} step={0.05}
            value={blendInTime}
            onChange={e => data.onChange?.('blendInTime', parseFloat(e.target.value) || 0)}
            onMouseDown={e => e.stopPropagation()}
            style={{
              width: 48, background: '#0e0618', border: '1px solid #2a1040',
              color: accent, padding: '2px 4px', borderRadius: 3,
              fontSize: 9, fontFamily: 'var(--m-mono)', outline: 'none', textAlign: 'right',
            }}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ color: '#5a3a7a', fontSize: 9, flex: 1 }}>Blend Out</span>
          <input
            type="number" min={0} max={5} step={0.05}
            value={blendOutTime}
            onChange={e => data.onChange?.('blendOutTime', parseFloat(e.target.value) || 0)}
            onMouseDown={e => e.stopPropagation()}
            style={{
              width: 48, background: '#0e0618', border: '1px solid #2a1040',
              color: accent, padding: '2px 4px', borderRadius: 3,
              fontSize: 9, fontFamily: 'var(--m-mono)', outline: 'none', textAlign: 'right',
            }}
          />
        </div>
      </div>

      {/* is-active output pin */}
      <div style={{ padding: '4px 12px 4px', display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center', gap: 5, position: 'relative',
                    borderTop: '1px solid #1e0a30' }}>
        <span style={{ color: '#3a2a4a', fontSize: 9 }}>is-active</span>
        <Handle type="source" position={Position.Right} id="is-active"
          style={{ background: active ? '#80ff80' : '#204020', width: 10, height: 10,
                   borderRadius: '50%', border: '2px solid #30603044',
                   position: 'relative', right: 'auto', transform: 'none' }} />
      </div>

      {/* tag output pin */}
      <div style={{ padding: '4px 12px 8px', display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center', gap: 5, position: 'relative' }}>
        <span style={{ color: '#3a2a4a', fontSize: 9 }}>tag</span>
        <Handle type="source" position={Position.Right} id="tag"
          style={{ background: active ? '#d0a0ff' : '#3a1a5a', width: 10, height: 10,
                   borderRadius: 3, border: '2px solid #50305044',
                   position: 'relative', right: 'auto', transform: 'none' }} />
      </div>
    </div>
  )
}
